import axios, {AxiosResponse} from 'axios';
import {AppConfig} from "@/app.config";

class Resource {

  getPageContent( { endpoint, id }: { endpoint: string, id?: number }) {
    let url = endpoint;
    let options = {};
    if (process.env.VUE_APP_MODE === 'loc' || process.env.VUE_APP_MODE === 'dev') {
      options = { headers: { 'Authorization': AppConfig.authKey ? `Basic ${AppConfig.authKey}` : '' } }
    }

    if (id) url += `/${id}`;
    url += `?t=${Date.now()}`;

    return (axios.get(url, options) as Promise<AxiosResponse>).then((response: AxiosResponse) => {
      return response.data;
    }).catch((error) => {
      console.error(error);
      return error.response;
    });
  }
}

export const pageContentResource = new Resource();
